/** gudang (warehouse) copy. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enGudang = {
  'gudang.nav.overview': 'Overview',
  'gudang.overview.title': 'Warehouse',
  'gudang.overview.subtitle': 'Warehouses of {branch}',
  'gudang.overview.warehouses': 'Warehouses',
  'gudang.overview.warehousesDesc':
    'Each active stock location is a warehouse. Zones and bins are set up per warehouse.',
  'gudang.overview.empty': 'No active stock locations yet.',
  'gudang.overview.addLocation': 'Add a location',
  'gudang.overview.default': 'Default',
  'gudang.overview.binsPending': 'No zones or bins yet — stock is kept per location.',
  'gudang.overview.binsOnShort': 'Bins on — stock is tracked per bin.',
  'gudang.overview.open': 'Open {name}',
  'gudang.layout.title': 'Warehouse layout',
  'gudang.layout.subtitle': 'Zones and bins of {code}',
  'gudang.layout.enabled': 'Bins are on. Current stock is in STAGING.',
  'gudang.layout.off': 'Bins are off',
  'gudang.layout.offDesc':
    'Stock is kept per location. Set up zones and bins, then turn bins on: the current stock goes to the STAGING bin until it is put away.',
  'gudang.layout.enable': 'Turn bins on',
  'gudang.layout.enableTitle': 'Turn bins on for {name}?',
  'gudang.layout.enableBody':
    'All stock at this location is placed in the STAGING bin. From then on every stock movement here also moves bin quantities.',
  'gudang.layout.enableWarning': 'This cannot be turned off again.',
  'gudang.zone.add': 'Add zone',
  'gudang.zone.title': 'Zones',
  'gudang.zone.desc': 'Areas with one storage condition, such as dry store, chiller or freezer.',
  'gudang.zone.empty': 'No zones yet.',
  'gudang.zone.range': '{min} to {max}',
  'gudang.zone.editNamed': 'Edit zone {code}',
  'gudang.zone.tempMin': 'Minimum temperature (°C)',
  'gudang.zone.tempMax': 'Maximum temperature (°C)',
  'gudang.zone.tempInvalid': 'Enter a temperature with at most one decimal, e.g. 4 or -18.5.',
  'gudang.zone.tempOrder': 'The minimum temperature must not exceed the maximum.',
  'gudang.bin.add': 'Add bin',
  'gudang.bin.needsZone': 'Add a zone first.',
  'gudang.bin.title': 'Bins',
  'gudang.bin.desc': 'Racks, shelves and bins. STAGING holds stock that has not been put away yet.',
  'gudang.bin.empty': 'No bins yet.',
  'gudang.bin.stagingHint': 'Unplaced stock (system)',
  'gudang.bin.notPickable': 'Not pickable',
  'gudang.bin.lines': '{count} lines',
  'gudang.bin.stock': 'Stock',
  'gudang.bin.stockOf': 'Stock in {code}',
  'gudang.bin.editNamed': 'Edit bin {code}',
  'gudang.bin.stagingEdit': 'STAGING is managed by the system; only its barcode can change.',
  'gudang.bin.barcodeHint':
    'Optional. Printed on the bin label and scanned instead of typing the code.',
  'gudang.bin.sequenceHint':
    'Lower numbers are picked first and emptied first by movements without a bin.',
  'gudang.bin.pickable': 'Pickable',
  'gudang.bin.pickableHint': 'Off for overflow or reserve bins that pickers should not use.',
  'gudang.bin.noStock': 'This bin is empty.',
  'gudang.bin.expires': 'Expires {date}',
  'gudang.col.code': 'Code',
  'gudang.col.name': 'Name',
  'gudang.col.storage': 'Storage',
  'gudang.col.temperature': 'Temperature',
  'gudang.col.status': 'Status',
  'gudang.col.actions': 'Actions',
  'gudang.col.zone': 'Zone',
  'gudang.col.sequence': 'Pick order',
  'gudang.col.barcode': 'Barcode',
  'gudang.col.stock': 'Stock',
  'gudang.col.item': 'Item',
  'gudang.col.lot': 'Lot',
  'gudang.col.qty': 'Quantity',
  'gudang.status.active': 'Active',
  'gudang.status.inactive': 'Inactive',
  'gudang.storage.ambient': 'Ambient',
  'gudang.storage.dry': 'Dry store',
  'gudang.storage.chiller': 'Chiller',
  'gudang.storage.freezer': 'Freezer',
  'gudang.storage.staging': 'Staging',
  'gudang.storage.quarantine': 'Quarantine',
  'gudang.saved': 'Saved.',
  'gudang.codeHint': 'Upper-case letters, digits and dash. Cannot be changed later.',
  'gudang.nav.receiving': 'Receiving',
  'gudang.nav.checklists': 'Checklists',
  'gudang.nav.quarantine': 'Quarantine',
  'gudang.receiving.title': 'Receiving',
  'gudang.receiving.subtitle': 'Deliveries to {branch}',
  'gudang.receiving.direct': 'Receive without PO',
  'gudang.receiving.expected': 'Expected deliveries',
  'gudang.receiving.expectedDesc': 'Approved purchase orders with quantities still to arrive.',
  'gudang.receiving.noExpected': 'Nothing expected.',
  'gudang.receiving.po': 'Purchase order',
  'gudang.receiving.supplier': 'Supplier',
  'gudang.receiving.expectedDate': 'Expected',
  'gudang.receiving.openLines': 'Still to arrive',
  'gudang.receiving.openLine': '{item}: {qty} {unit}',
  'gudang.receiving.receive': 'Receive',
  'gudang.receiving.receiveNamed': 'Receive {number}',
  'gudang.receiving.receipts': 'Receipts',
  'gudang.receiving.noReceipts': 'No receipts yet.',
  'gudang.receiving.number': 'Number',
  'gudang.receiving.source': 'Source',
  'gudang.receiving.lines': 'Lines',
  'gudang.receiving.value': 'Value',
  'gudang.receipt.status.draft': 'Draft',
  'gudang.receipt.status.posted': 'Posted',
  'gudang.receipt.status.cancelled': 'Cancelled',
  'gudang.receipt.title': 'Goods receipt',
  'gudang.receipt.subtitle': '{seller} · {source} · into {location}',
  'gudang.receipt.post': 'Post receipt',
  'gudang.receipt.postTitle': 'Post {number}?',
  'gudang.receipt.postBody':
    'Accepted goods enter stock at their value; quarantined goods go to the quarantine location; rejected goods are not stocked. Posting cannot be undone.',
  'gudang.receipt.posted': 'Receipt posted.',
  'gudang.receipt.inspectFirst': 'Inspect the highlighted lines before posting.',
  'gudang.receipt.lines': 'Lines',
  'gudang.receipt.linesDesc': 'Delivered, rejected and quarantined quantities in the line unit.',
  'gudang.receipt.delivered': 'Delivered',
  'gudang.receipt.rejected': 'Rejected',
  'gudang.receipt.quarantined': 'Quarantined',
  'gudang.receipt.inspection': 'Inspection',
  'gudang.receipt.ordered': 'of {qty} ordered',
  'gudang.receipt.total': 'Total accepted value:',
  'gudang.receipt.back': 'Back to receiving',
  'gudang.receipt.quantities': 'What arrived',
  'gudang.receipt.quantitiesDesc':
    'Correct the delivered quantity, lot and expiry before inspecting.',
  'gudang.receipt.quantitiesReset':
    'Saving changed quantities discards the inspections done so far.',
  'gudang.receipt.expiry': 'Expiry date',
  'gudang.receipt.saveQuantities': 'Save quantities',
  'gudang.inspection.not_inspected': 'Not inspected',
  'gudang.inspection.passed': 'Passed',
  'gudang.inspection.partial': 'Partly held back',
  'gudang.inspection.failed': 'Failed',
  'gudang.inspection.required': 'Inspection required',
  'gudang.inspection.inspect': 'Inspect',
  'gudang.inspection.inspectNamed': 'Inspect {item}',
  'gudang.inspection.title': 'Inspect {item}',
  'gudang.inspection.delivered': 'Delivered: {qty} {unit}',
  'gudang.inspection.rejectQty': 'Rejected at the door ({unit})',
  'gudang.inspection.rejectReasonLabel': 'Reason for rejection',
  'gudang.inspection.quarantineQty': 'To quarantine ({unit})',
  'gudang.inspection.quarantineReasonLabel': 'Reason for quarantine',
  'gudang.inspection.temperature': 'Temperature on arrival (°C)',
  'gudang.inspection.notes': 'Notes',
  'gudang.inspection.save': 'Save inspection',
  'gudang.inspection.saved': 'Inspection saved.',
  'gudang.inspection.tooMuch':
    'Rejected and quarantined together cannot exceed the delivered quantity.',
  'gudang.inspection.rejectReason': 'Give a reason for the rejected quantity.',
  'gudang.inspection.quarantineReason': 'Give a reason for the quarantined quantity.',
  'gudang.direct.title': 'Receive without purchase order',
  'gudang.direct.subtitle': 'For goods bought on the spot, e.g. at the market.',
  'gudang.direct.supplier': 'Supplier',
  'gudang.direct.supplierHint': 'Or leave empty and type who sold it.',
  'gudang.direct.noSupplier': 'No supplier record',
  'gudang.direct.vendor': 'Sold by',
  'gudang.direct.vendorHint': 'Stall, shop or person — kept for traceability.',
  'gudang.direct.location': 'Receive into',
  'gudang.direct.defaultLocation': 'Main location',
  'gudang.direct.reference': 'Receipt / note number',
  'gudang.direct.lines': 'Goods',
  'gudang.direct.chooseItem': 'Choose an item',
  'gudang.direct.unit': 'Unit',
  'gudang.direct.qty': 'Quantity',
  'gudang.direct.price': 'Price per unit ({currency})',
  'gudang.direct.removeLine': 'Remove line {n}',
  'gudang.direct.addLine': 'Add line',
  'gudang.direct.create': 'Create receipt',
  'gudang.direct.err.seller': 'Choose a supplier or enter who sold the goods.',
  'gudang.direct.err.item': 'Choose an item.',
  'gudang.direct.err.qty': 'Enter a quantity above zero.',
  'gudang.direct.err.precision': 'This quantity does not convert exactly to the base unit.',
  'gudang.direct.err.price': 'Enter the price per unit.',
  'gudang.quarantine.title': 'Quarantine',
  'gudang.quarantine.subtitle': 'Stock held back by quality control and open warehouse cases.',
  'gudang.quarantine.stock': 'In quarantine',
  'gudang.quarantine.stockDesc':
    'Owned and valued, but never used for sales, transfers or picking until released.',
  'gudang.quarantine.empty': 'Nothing in quarantine.',
  'gudang.quarantine.release': 'Release',
  'gudang.quarantine.releaseNamed': 'Release {item}',
  'gudang.quarantine.releaseTitle': 'Release {item}',
  'gudang.quarantine.qty': 'Quantity ({unit})',
  'gudang.quarantine.to': 'Move to',
  'gudang.quarantine.reason': 'Reason',
  'gudang.quarantine.closesException': 'Releasing the full quantity also closes its open case.',
  'gudang.quarantine.released': 'Released from quarantine.',
  'gudang.quarantine.qtyInvalid': 'Enter a quantity up to what is in quarantine.',
  'gudang.quarantine.reasonRequired': 'Give a reason of at least 3 characters.',
  'gudang.exception.title': 'Open cases',
  'gudang.exception.desc': 'Quarantined or rejected goods and differences that need a decision.',
  'gudang.exception.empty': 'No open cases.',
  'gudang.exception.type': 'Case',
  'gudang.exception.reason': 'Reason',
  'gudang.exception.source': 'Document',
  'gudang.exception.type.qc_quarantine': 'Quarantined',
  'gudang.exception.type.supplier_rejection': 'Rejected at receipt',
  'gudang.exception.type.transfer_variance': 'Transfer difference',
  'gudang.exception.type.issue_variance': 'Issue difference',
  'gudang.exception.type.other': 'Other',
  'gudang.exception.resolve': 'Close case',
  'gudang.exception.resolveNamed': 'Close case for {item}',
  'gudang.exception.resolveTitle': 'Close case for {item}',
  'gudang.exception.resolution': 'Outcome',
  'gudang.exception.resolution.returned': 'Returned to supplier',
  'gudang.exception.resolution.accepted': 'Accepted as is',
  'gudang.exception.resolution.other': 'Other',
  'gudang.exception.action.return': 'Return to supplier',
  'gudang.exception.action.replacement': 'Replacement shipment',
  'gudang.exception.action.credit_claim': 'Supplier credit',
  'gudang.exception.action.accepted_release': 'Accept and release',
  'gudang.exception.supplierReference': 'Supplier reference',
  'gudang.exception.replacementReceipt': 'Replacement receipt ID',
  'gudang.exception.creditNote': 'Posted credit note ID',
  'gudang.exception.acknowledge': 'Record acknowledgement',
  'gudang.exception.acknowledged': 'Supplier acknowledgement recorded.',
  'gudang.exception.acknowledgedBy': 'Supplier acknowledgement: {reference}',
  'gudang.exception.complete': 'Complete resolution',
  'gudang.exception.note': 'Note',
  'gudang.exception.quarantineHint':
    'Closing does not move stock: release it or record waste for it separately.',
  'gudang.exception.resolved': 'Case closed.',
  'gudang.checklist.title': 'Receiving checklists',
  'gudang.checklist.subtitle': 'What to check when goods arrive, per item category.',
  'gudang.checklist.add': 'Add checklist',
  'gudang.checklist.list': 'Checklists',
  'gudang.checklist.listDesc':
    'A category uses its own checklist, otherwise the one for all categories.',
  'gudang.checklist.empty': 'No checklists yet — inspection stays optional.',
  'gudang.checklist.category': 'Item category',
  'gudang.checklist.categoryHint': 'Leave empty for all categories without their own checklist.',
  'gudang.checklist.allCategories': 'All categories',
  'gudang.checklist.questions': 'Questions',
  'gudang.checklist.question': 'Question {n}',
  'gudang.checklist.removeQuestion': 'Remove question {n}',
  'gudang.checklist.addQuestion': 'Add question',
  'gudang.checklist.required': 'Inspection required',
  'gudang.checklist.requiredHint':
    'Receipts with these items cannot be posted until each line is inspected.',
  'gudang.checklist.editNamed': 'Edit {name}',
  'gudang.checklist.incomplete': 'Enter a name and at least one question.',
  'gudang.nav.tasks': 'Tasks',
  'gudang.zone.categories': 'Allowed item categories',
  'gudang.zone.categoriesHint':
    'Optional, separated by commas, e.g. Dairy, Meat. Items of other categories cannot be put away in this zone.',
  'gudang.zone.onlyCategories': 'Only: {list}',
  'gudang.move.action': 'Move',
  'gudang.move.named': 'Move {item}',
  'gudang.move.title': 'Move {item} from {code}',
  'gudang.move.to': 'To bin',
  'gudang.move.qty': 'Quantity ({unit})',
  'gudang.move.reason': 'Reason (optional)',
  'gudang.move.noTarget': 'No other bin can take this item.',
  'gudang.move.qtyInvalid': 'Enter a quantity above zero, at most what the bin holds.',
  'gudang.move.done': 'Stock moved.',
  'gudang.tasks.title': 'Putaway tasks',
  'gudang.tasks.subtitle': 'Stock waiting in STAGING to be put away in bins',
  'gudang.tasks.filter': 'Show tasks',
  'gudang.tasks.filter.open': 'Open',
  'gudang.tasks.filter.mine': 'Mine',
  'gudang.tasks.filter.done': 'Done',
  'gudang.tasks.empty': 'Nothing to put away.',
  'gudang.tasks.emptyMine': 'You have no tasks. Take one from the open list.',
  'gudang.tasks.emptyDone': 'No finished tasks yet.',
  'gudang.tasks.remaining': '{qty} to put away',
  'gudang.tasks.staged': 'Only {qty} is still in STAGING',
  'gudang.tasks.lot': 'Lot {lot}',
  'gudang.tasks.expires': 'expires {date}',
  'gudang.tasks.source.goods_receipt': 'Receipt',
  'gudang.tasks.source.stock_transfer': 'Transfer',
  'gudang.tasks.source.quarantine_release': 'Quarantine release',
  'gudang.tasks.source.opening_balance': 'Opening balance',
  'gudang.tasks.source.stock_count': 'Stock count',
  'gudang.tasks.source.other': 'Stock movement',
  'gudang.tasks.assignee': 'Assigned to {name}',
  'gudang.tasks.unassigned': 'Unassigned',
  'gudang.tasks.overdue': 'Overdue',
  'gudang.tasks.due': 'Due {time}',
  'gudang.tasks.claim': 'Take',
  'gudang.tasks.claimNamed': 'Take the task for {item}',
  'gudang.tasks.claimed': 'Task taken.',
  'gudang.tasks.release': 'Let go',
  'gudang.tasks.releaseNamed': 'Let go of the task for {item}',
  'gudang.tasks.released': 'Task released.',
  'gudang.tasks.putAway': 'Put away',
  'gudang.tasks.putAwayNamed': 'Put away {item}',
  'gudang.tasks.cancel': 'Cancel task',
  'gudang.tasks.cancelNamed': 'Cancel the task for {item}',
  'gudang.tasks.cancelTitle': 'Cancel putaway of {item}?',
  'gudang.tasks.cancelBody':
    'The stock stays where it is. Move it later from the bin list of the warehouse.',
  'gudang.tasks.cancelReason': 'Reason',
  'gudang.tasks.reasonRequired': 'Enter a reason of at least 3 characters.',
  'gudang.tasks.cancelled': 'Task cancelled.',
  'gudang.tasks.statusDone': 'Done',
  'gudang.tasks.statusCancelled': 'Cancelled',
  'gudang.tasks.finishedAt': 'Closed {time}',
  'gudang.putaway.title': 'Put away {item}',
  'gudang.putaway.summary': '{qty} to put away from STAGING at {location}',
  'gudang.putaway.scan': 'Scan or type a bin',
  'gudang.putaway.scanHint': 'Scan the bin label, or type its code and press Enter.',
  'gudang.putaway.unknownBin': 'There is no bin “{code}” in this warehouse.',
  'gudang.putaway.suggested': 'Suggested bins',
  'gudang.putaway.useBin': 'Use bin {code}',
  'gudang.putaway.reason.same_lot': 'same lot',
  'gudang.putaway.reason.same_item': 'same item',
  'gudang.putaway.reason.empty': 'empty',
  'gudang.putaway.reason.other': 'shared',
  'gudang.putaway.placements': 'Placements',
  'gudang.putaway.none': 'Scan a bin or choose a suggestion.',
  'gudang.putaway.qtyFor': 'Quantity for {code} ({unit})',
  'gudang.putaway.remove': 'Remove {code}',
  'gudang.putaway.left': 'Left after this: {qty}',
  'gudang.putaway.qtyInvalid': 'Each quantity must be above zero and together at most {qty}.',
  'gudang.putaway.confirm': 'Confirm putaway',
  'gudang.putaway.done': 'Stock put away.',
  'gudang.nav.requisitions': 'Requests',
  'req.col.actions': 'Actions',
  'req.col.approved': 'Approved',
  'req.col.code': 'Code',
  'req.col.issued': 'Issued',
  'req.col.item': 'Item',
  'req.col.items': 'Items',
  'req.col.number': 'Number',
  'req.col.picked': 'Picked',
  'req.col.received': 'Received',
  'req.col.requested': 'Requested',
  'req.col.requestedAt': 'Requested',
  'req.col.requestedBy': 'Requested by',
  'req.col.status': 'Status',
  'req.status.draft': 'Draft',
  'req.status.submitted': 'Waiting for approval',
  'req.status.approved': 'Approved',
  'req.status.picking': 'Picking',
  'req.status.issued': 'Handed over',
  'req.status.completed': 'Received',
  'req.status.rejected': 'Rejected',
  'req.status.cancelled': 'Cancelled',
  'req.more': '+{count} more',
  'req.queue.title': 'Kitchen requests',
  'req.queue.subtitle': 'Approve, pick and hand over ingredients the kitchen asked for',
  'req.queue.filter': 'Show requests',
  'req.queue.todo': 'To do',
  'req.queue.issued': 'Awaiting kitchen',
  'req.queue.closed': 'Closed',
  'req.queue.empty': 'No requests here.',
  'req.detail.route': '{from} → {to}',
  'req.detail.approve': 'Approve',
  'req.detail.approveTitle': 'Approve {number}',
  'req.detail.approveQty': '{item} ({unit})',
  'req.detail.approveInvalid': 'Approve a quantity from 0 up to what was requested for each item.',
  'req.detail.approved': 'Request approved.',
  'req.detail.note': 'Note (optional)',
  'req.detail.selfNote': 'Reason for approving your own request',
  'req.detail.selfNoteHint':
    'Required: you requested this yourself. It is recorded as a self-approval.',
  'req.detail.reject': 'Reject',
  'req.detail.rejectTitle': 'Reject {number}?',
  'req.detail.rejected': 'Request rejected.',
  'req.detail.reason': 'Reason',
  'req.detail.cancel': 'Cancel request',
  'req.detail.cancelTitle': 'Cancel {number}?',
  'req.detail.cancelPicking': 'Reserved stock is released and open picks are closed.',
  'req.detail.cancelled': 'Request cancelled.',
  'req.detail.cancelReason': 'Cancelled because',
  'req.detail.startPicking': 'Start picking',
  'req.detail.pickingStarted': 'Stock reserved; pick list ready.',
  'req.detail.quickIssue': 'Hand over now',
  'req.detail.issue': 'Hand over',
  'req.detail.issued': 'Ingredients handed over to the kitchen.',
  'req.detail.finishPicks': 'Finish every pick first.',
  'req.detail.estimate': 'Estimated value',
  'req.detail.decision': 'Decision',
  'req.detail.automatic': 'Automatic',
  'req.detail.issuedBy': 'Handed over by',
  'req.detail.confirmedBy': 'Received by',
  'req.detail.lines': 'Items',
  'req.detail.actions': 'Request actions',
  'req.detail.linesDesc':
    'Requested, approved, picked, and handed-over quantities remain visible throughout this request.',
  'req.detail.searchLines': 'Search item or code',
  'req.detail.progressFilter': 'Progress',
  'req.detail.allProgress': 'All progress',
  'req.detail.progress.pending': 'Pending',
  'req.detail.progress.complete': 'Full quantity',
  'req.detail.progress.adjusted': 'Adjusted quantity',
  'req.pick.title': 'Pick list',
  'req.pick.desc': 'Earliest expiry first. Take each line from its bin and mark it picked.',
  'req.pick.bin': 'Bin',
  'req.pick.lot': 'Lot',
  'req.pick.qty': 'Quantity',
  'req.pick.expires': 'Expires {date}',
  'req.pick.ofPlanned': '{done} of {planned}',
  'req.pick.picked': 'Picked',
  'req.pick.pickedNamed': 'Picked {item} from {bin}',
  'req.pick.short': 'Short',
  'req.pick.shortNamed': 'Record a short pick of {item}',
  'req.pick.shortTitle': 'Short pick of {item}',
  'req.pick.shortHint': 'Enter what you actually found. The rest of the reservation is released.',
  'req.pick.foundQty': 'Found ({unit})',
  'req.pick.shortInvalid': 'Enter a quantity below {qty}.',
  'req.pick.status.open': 'To pick',
  'req.pick.status.done': 'Picked',
  'req.pick.status.short': 'Short',
  'req.pick.status.cancelled': 'Cancelled',
  'req.kitchen.title': 'Ingredient requests',
  'req.kitchen.subtitle': 'Ask the warehouse for ingredients and confirm what arrives',
  'req.kitchen.new': 'New request',
  'req.kitchen.empty': 'No requests yet.',
  'req.kitchen.send': 'Send request',
  'req.kitchen.sent': 'Request sent to the warehouse.',
  'req.kitchen.linesInvalid': 'Choose an item and a quantity above zero on every line.',
  'req.kitchen.duplicateItem': 'Each item can appear only once.',
  'req.kitchen.confirm': 'Confirm receipt',
  'req.kitchen.confirmNamed': 'Confirm receipt of {number}',
  'req.kitchen.confirmTitle': 'What arrived for {number}?',
  'req.kitchen.confirmHint':
    'Enter what actually arrived. Any difference is reported to the warehouse.',
  'req.kitchen.receivedOf': '{item} received ({unit}) — {qty} handed over',
  'req.kitchen.receivedInvalid': 'Enter a quantity from 0 up to what was handed over.',
  'req.kitchen.noteRequired': 'Say what was missing or damaged.',
  'req.kitchen.note': 'Note',
  'req.kitchen.confirmed': 'Receipt confirmed.',
  'req.field.from': 'From',
  'req.field.to': 'To',
  'req.field.lines': 'Ingredients',
  'req.field.item': 'Item {n}',
  'req.field.chooseItem': 'Choose an item',
  'req.field.qty': 'Quantity ({unit})',
  'req.field.removeLine': 'Remove line {n}',
  'req.field.addLine': 'Add item',
  'gudang.direct.emergency': 'Emergency purchase outside the normal PR/PO process',
  'gudang.direct.emergencyReason': 'Emergency reason',
  'gudang.direct.emergencyHint':
    'Explain why the normal approval and purchasing process could not be followed. Another person must review it.',
  'gudang.direct.err.emergencyReason': 'Give an emergency reason of at least 3 characters.',
  'gudang.emergency.title': 'Emergency purchase',
  'gudang.emergency.not_required': 'Review not required',
  'gudang.emergency.pending': 'Review pending',
  'gudang.emergency.approved': 'Emergency purchase approved',
  'gudang.emergency.rejected': 'Emergency purchase rejected',
  'gudang.emergency.approve': 'Approve exception',
  'gudang.emergency.reject': 'Reject exception',
  'gudang.emergency.approveTitle': 'Approve this emergency purchase?',
  'gudang.emergency.rejectTitle': 'Reject this emergency purchase?',
  'gudang.emergency.reviewBody':
    'Record the decision after checking why the normal purchase process was bypassed.',
  'gudang.emergency.reviewNote': 'Review note',
  'gudang.emergency.reviewedBy': 'Reviewed by {name}',
} as const;
